import React from 'react';
import xhr from './../../../../utils/xhr';
import { FormattedMessage } from 'react-intl';
import { hashHistory } from 'react-router';
import ButtonWithInnerSpinner from './../../../../reusable/ButtonWithInnerSpinner/ButtonWithInnerSpinner.index';

export default class ReviewEntitiesButtonAndParagraphs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            buttonState: "loading",
            paragraphClass: "hidden"
        }
    }

    componentWillMount() {
        return xhr.get({
            url: '/api/entities/companies/non-active/count'
        }).then((response) => {
            if (response.body == 0) {
                this.setState({
                    buttonState: "disabled",
                    paragraphClass: ""
                });
            } else {
                this.setState({
                    buttonState: "enabled",
                    paragraphClass: "hidden"
                });
            }
        }).catch((error) => {
            xhr.handleAllErrors(error);
        });
    }

    goToReview = ()=> {
        hashHistory.push('/review-companies');
    };

    render() {

        return (
            <div>

                <p className={"disabled-text " + this.state.paragraphClass}>
                    <FormattedMessage id="Entities_Steps_UIText_batchUpload.step3Instruction2" />
                    <FormattedMessage id="Entities_Steps_UIText_batchUpload.step3Instruction3" />
                </p>

                <div className="button-wrapper">

                    <ButtonWithInnerSpinner buttonType="button"
                                            buttonClass="button-primary-lg upload-wizard__buttons"
                                            buttonClick={this.goToReview}
                                            buttonMessageId="Entities_Steps_UIText_batchUpload.buttonReviewCompanies"
                                            buttonState={this.state.buttonState} />

                </div>

            </div>
        );

    }
}


// WEBPACK FOOTER //
// ./src/scripts/pages/BatchUpload/submodules/InitialStage/ReviewEntitiesButtonAndParagraphs.jsx